define.alias("shared/components/shared/publish/switcher/item/business-button", "media/components/shared/publish/switcher/item/business-button");